/* eslint no-param-reassign: 0 */

const mutations = {
  SET_INIT(state) {
    state.initialized = true;
  },
};

export default mutations;
